module.exports = __webpack_public_path__ + "img/movie-roll-band.abc6fa5d.svg";